module.exports = __webpack_public_path__ + "img/svg/position-1.a6ce62c8480ceb79dccda23189899884.svg";